import React, { useEffect, useState } from 'react';
import styles from './index.module.scss'
import AppCtrl from "../../../../control/AppCtrl";
import Config from '../../../../utils/Config';
import Table from '../../../_component/Table';
import moment from 'moment';
//import LANGUAGE_TYPE from "../../../utils/Language"

function GiftRecordsPage(props) {
    const text = Config.text.giftRecordsPage;

    //===========================================================================
    useEffect(() => {
        //PreLoad();
        componentDidMount();
        return componentWillUnmount;
    }, []);
    // useEffect(() => {
    //     if (props.records) onQueryUserGiftRecords(props.records);
    // }, [props.records]);
    //===========================================================================

    function componentDidMount() {
        window.addEventListener('resize', onResize);
        onResize();

        // const offset = new Date().getTimezoneOffset();
        // console.log(`offset:${offset}`);
        // var curTime = new Date();
        // const year = curTime.getFullYear();
        // const month = curTime.getMonth();
        // const date = curTime.getDate();
        // const hour = offset / -60;
        // curTime = new Date(year, month, date, hour, 0, 0);
        // const uiETime = document.getElementById('eGiftRecordsTime');
        // if (uiETime) uiETime.valueAsDate = curTime;
        // const uiSTime = document.getElementById('sGiftRecordsTime');
        // if (uiSTime) uiSTime.valueAsDate = new Date(curTime.getTime() - 6*24*60*60*1000);
    }

    // function componentDidUpdate()
    // {
    // }

    function componentWillUnmount() {
        window.removeEventListener('resize', onResize);
    }

    function onResize() {
        const deviceWidth = window.innerWidth;
        const deviceHeight = window.innerHeight;

        const uiGiftRecordsPage = document.getElementById('giftRecordsPage');
        if (uiGiftRecordsPage) {
            //uiGiftRecordsPage.style.paddingRight = `5px`;
            uiGiftRecordsPage.style.height = `${deviceHeight}px`;
            uiGiftRecordsPage.style.overflowY = "auto";
        }
    }

    // function onQueryUserGiftRecords(records)
    // {
    //     const giftList = records;
    //     const uiTbodyGiftRecords = document.getElementById('tbodyGiftRecords');
    //     if (uiTbodyGiftRecords) {
    //         let content = "";
    //         for (let i = 0 ; i < giftList.length ; i++) {
    //             const objGift = JSON.parse(giftList[i].Content);
    //             const createTime = new Date(giftList[i].CreateTime);
    //             const year = createTime.getFullYear();
    //             const month = createTime.getMonth()+1 < 10 ? `0${createTime.getMonth()+1}` : createTime.getMonth()+1;
    //             const date = createTime.getDate() < 10 ? `0${createTime.getDate()}` : createTime.getDate();
    //             const hours = createTime.getHours() < 10 ? `0${createTime.getHours()}` : createTime.getHours();
    //             const minutes = createTime.getMinutes() < 10 ? `0${createTime.getMinutes()}` : createTime.getMinutes();
    //             const seconds = createTime.getSeconds() < 10 ? `0${createTime.getSeconds()}` : createTime.getSeconds();
    //             content += '<tr>';
    //             content +=  `<td>${i+1}</td>`;
    //             content +=  `<td>${year}/${month}/${date} ${hours}:${minutes}:${seconds}</td>`;
    //             content +=  `<td>${giftList[i].User}</td>`;
    //             content +=  `<td>${giftList[i].Target}</td>`;
    //             switch (giftList[i].Type) {
    //                 case 1:
    //                     content +=  `<td>分數:${objGift.coins}</td>`;
    //                     break;
    //                 default:
    //                     break;
    //             }
    //             content += '</tr>';
    //         }

    //         uiTbodyGiftRecords.innerHTML = content;
    //     }
    // }

    const columns = [
        { key: 'index', title: 'NO.', width: '5%' },
        { key: 'time', title: `${text.time}`, width: '30%' },
        { key: 'from', title: `${text.from}` },
        { key: 'to', title: `${text.to}` },
        { key: 'coins', title: `${text.type}`, width: '40%' },
    ]

    const data = (records) => {
        return records.map((record, index) => {
            const objGift = JSON.parse(record.Content);
            const time = moment(record.CreateTime).format("YYYY/MM/DD HH:mm:ss");
            return {
                index: index + 1,
                time,
                from: record.User,
                to: record.Target,
                coins: `分數:${objGift.coins}`,
            }
        })
    }

    return (
        <div id="giftRecordsPage" className={styles.giftRecordsPage}>
            {/* <table style={{width:"100%", borderCollapse:"separate", borderSpacing:"0 2px", cellpadding:"10", border:"1"}}>
                <thead>
                    <tr style={{color:"white", backgroundColor:"#FFC107"}}>
                        <th style={{width:"5%", textAlign:"center", fontSize:"16px"}}>NO.</th>
                        <th id='time' style={{width:"30%", textAlign:"center", fontSize:"16px"}}>{`${text.time}`}</th>
                        <th id='from' style={{width:"12%", textAlign:"center", fontSize:"16px"}}>{`${text.from}`}</th>
                        <th id='to' style={{width:"12%", textAlign:"center", fontSize:"16px"}}>{`${text.to}`}</th>
                        <th id='type' style={{width:"40%", textAlign:"center", fontSize:"16px"}}>{`${text.type}`}</th>
                    </tr>
                </thead>
                <tbody id="tbodyGiftRecords">
                </tbody>
            </table> */}
            {props.records && props.records.length > 0 && <Table columns={columns} data={data(props.records)} />}
        </div>
    );
}

export default GiftRecordsPage;